import { Component, OnInit } from '@angular/core';
import { Globals } from '../_globals';

@Component({
    selector: 'app-user-profile',
    templateUrl: './user-profile.component.html',
    styleUrls: ['./user-profile.component.css']
})
export class UserProfileComponent implements OnInit {

    constructor(
        public globals: Globals
    ) { }

    ngOnInit() {
    }

}



// WEBPACK FOOTER //
// ./src/app/user-profile/user-profile.component.ts